import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import WavesBottom from "../components/WavesBottom";
import { PageRendererProps, Link } from "gatsby";

const ImprintPage = ({ location }: PageRendererProps) => {
  return (
    <Layout location={location}>
      <Seo title="Impressum" />

      <section className="py-20 bg-white">
        <div className="container max-w-5xl p-6 m-8 mx-auto">
          <h2 className="w-full my-8 font-bold leading-tight text-center text-gray-800 sm:text-3xl lg:text-5xl">
            Impressum
          </h2>
          <p className="mb-8 text-gray-600">
            getsby GmbH
            <br />
            Media Quarter Marx 3.2, Maria-Jacobi Gasse 1<br />
            A-1030 Wien
            <br />
            UID: ATU75803025
            <br />
            FN: 538605t des Firmenbuches des HG Wien
          </p>
          <p className="mb-8 text-gray-600">
            Gesellschaftsform: Gesellschaft mit beschränkter Haftung
            <br />
            Unternehmensgegenstand: Dienstleistungen in der Informations- und
            Kommunikationstechnologie
          </p>
          <p className="mb-8 text-gray-600">
            Firmenbuchnummer: 538605t
            <br />
            Gerichtsstand: Handelsgericht Wien
          </p>
          <p className="mb-8 text-gray-600">
            Geschäftsführer: Johannes Angelo Laub, Mathias Müller
          </p>
          <p className="mb-8 text-gray-600">
            <a className="text-yellow-500" href="mailto:office@gets.by">
              office@gets.by
            </a>
            <br />
            Tel +43 (0) 660 3411244
            <br />
            Tel +43 (0) 670 5053377
          </p>
          <p className="mb-8 text-gray-600">
            Verbraucher haben die Möglichkeit, Beschwerden an die
            Online-Streitbeilegungsplattform der EU zu richten:
            <br />
            <a
              className="text-yellow-500"
              href="http://ec.europa.eu/odr"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://ec.europa.eu/odr
            </a>
          </p>
          <p className="mb-8 text-gray-600">
            Sie können allfällige Beschwerde auch an die oben angegebene
            E-mail-Adresse richten.
          </p>
          <p className="mb-8 text-gray-600">
            Unsere Datenschutzerklärung findest du{" "}
            <Link to="/privacy-policy" className="text-yellow-500">
              hier
            </Link>
          </p>
          <p className="mb-8 text-gray-600">
            Unsere AGBs findest du hier:
            <br />
            <Link to="/gtc" className="text-yellow-500">
              AGBs
            </Link>
            <br />
            <Link to="/referral" className="text-yellow-500">
              Freunde werben
            </Link>
          </p>
          <p className="mb-8 text-gray-600">
            DISCLAIMER: Die getsby GmbH ist nicht verantwortlich für die
            Funktionalität und Inhalte externer Links.
          </p>
          <p className="mb-8 text-gray-600">
            App-Credits: <br />
            Icons made by{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/epiccoders"
              title="EpicCoders"
            >
              EpicCoders
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/vectors-market"
              title="Vectors Market"
            >
              Vectors Market
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/kiranshastry"
              title="Kiranshastry"
            >
              Kiranshastry
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="http://www.freepik.com"
              title="Freepik"
            >
              Freepik
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/smashicons"
              title="Smashicons"
            >
              Smashicons
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/gregor-cresnar"
              title="Gregor Cresnar"
            >
              Gregor Cresnar
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/retinaicons"
              title="retinaicons"
            >
              retinaicons
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/creaticca-creative-agency"
              title="creaticca-creative-agency"
            >
              creaticca-creative-agency
            </a>
            ,{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/pixel-buddha"
              title="Pixel Buddha"
            >
              Pixel Buddha
            </a>{" "}
            and{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/authors/hadrien"
              title="Hadrien"
            >
              Hadrien
            </a>{" "}
            from{" "}
            <a
              className="text-yellow-500"
              href="https://www.flaticon.com/"
              title="Flaticon"
            >
              www.flaticon.com
            </a>{" "}
            are licensed by{" "}
            <a
              className="text-yellow-500"
              href="http://creativecommons.org/licenses/by/3.0/"
              title="Creative Commons BY 3.0"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC 3.0 BY
            </a>
          </p>
        </div>
      </section>

      <WavesBottom />
    </Layout>
  );
};

export default ImprintPage;
